/* ============================================================
   Brand Directory ("Shop by Brand" A–Z) — bm-brand-directory
   Progressive enhancement over server-rendered markup:
   search filtering, suggestions, A–Z jump, lazy live counts.
   ============================================================ */
(function () {
  var LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  // Shared cache of vendor -> count string (dedupes popular + directory + repeat views).
  var countCache = {};

  function init(root) {
    if (root.dataset.bmbdInit === "1") return;
    root.dataset.bmbdInit = "1";

    var input = root.querySelector("[data-search]");
    var clearBtn = root.querySelector("[data-clear]");
    var suggBox = root.querySelector("[data-suggestions]");
    var azBar = root.querySelector("[data-az-bar]");
    var groups = Array.prototype.slice.call(root.querySelectorAll("[data-letter-group]"));
    var cards = Array.prototype.slice.call(root.querySelectorAll(".bmbd-card"));
    var noResults = root.querySelector("[data-no-results]");
    var finderCount = root.querySelector("[data-finder-count]");
    var directorySub = root.querySelector("[data-directory-sub]");
    var total = parseInt((finderCount && finderCount.dataset.total) || cards.length, 10);

    // Brand index built from the rendered DOM (no duplicate data island).
    var brands = cards.map(function (card) {
      return {
        card: card,
        name: card.querySelector(".bmbd-dir-name") ? card.querySelector(".bmbd-dir-name").textContent.trim() : "",
        key: card.dataset.name || "",
        vendor: card.dataset.vendor || "",
        href: card.getAttribute("href")
      };
    });

    var activeLetters = {};
    groups.forEach(function (g) { activeLetters[g.dataset.letterGroup] = true; });

    /* ---------- A–Z bar ---------- */
    if (azBar) {
      azBar.innerHTML = LETTERS.map(function (l) {
        var disabled = activeLetters[l] ? "" : " is-disabled";
        return '<div class="bmbd-az-btn' + disabled + '" data-letter="' + l + '">' + l + "</div>";
      }).join("");
      azBar.querySelectorAll(".bmbd-az-btn:not(.is-disabled)").forEach(function (btn) {
        btn.addEventListener("click", function () { jumpToLetter(btn.dataset.letter); });
      });
    }

    function jumpToLetter(letter) {
      azBar.querySelectorAll(".bmbd-az-btn").forEach(function (b) {
        b.classList.toggle("is-active", b.dataset.letter === letter);
      });
      var target = root.querySelector('[data-letter-label="' + letter + '"]');
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    /* ---------- search highlight ---------- */
    function highlight(name, query) {
      if (!query) return escapeHtml(name);
      var idx = name.toLowerCase().indexOf(query.toLowerCase());
      if (idx === -1) return escapeHtml(name);
      return escapeHtml(name.slice(0, idx)) + "<b>" + escapeHtml(name.slice(idx, idx + query.length)) + "</b>" + escapeHtml(name.slice(idx + query.length));
    }
    function escapeHtml(s) {
      return s.replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }

    /* ---------- suggestions ---------- */
    function renderSuggestions(query) {
      if (!suggBox) return;
      if (!query) { suggBox.classList.remove("is-open"); suggBox.innerHTML = ""; return; }
      var q = query.toLowerCase();
      var matches = brands.filter(function (b) { return b.key.indexOf(q) !== -1; }).slice(0, 6);
      if (matches.length === 0) {
        suggBox.innerHTML = '<div class="bmbd-suggestions-empty">No brands match “' + escapeHtml(query) + '”</div>';
      } else {
        suggBox.innerHTML = matches.map(function (b) {
          return '<a class="bmbd-suggestion-item" href="' + b.href + '" data-name="' + escapeHtml(b.name) + '">' +
            '<span class="bmbd-sugg-badge">' + escapeHtml(b.name.charAt(0).toUpperCase()) + "</span>" +
            '<span class="bmbd-sugg-name">' + highlight(b.name, query) + "</span>" +
            "</a>";
        }).join("");
      }
      suggBox.classList.add("is-open");
    }

    /* ---------- filter directory ---------- */
    function filter(query) {
      var q = (query || "").trim().toLowerCase();
      if (clearBtn) clearBtn.classList.toggle("is-visible", !!q);

      var shown = 0;
      brands.forEach(function (b) {
        var match = !q || b.key.indexOf(q) !== -1;
        b.card.style.display = match ? "" : "none";
        if (match) shown++;
      });

      // Hide letter groups with no visible cards.
      groups.forEach(function (g) {
        var visible = g.querySelectorAll('.bmbd-card:not([style*="display: none"])').length;
        g.style.display = visible ? "" : "none";
      });

      if (noResults) noResults.classList.toggle("is-visible", shown === 0);

      if (finderCount) {
        finderCount.textContent = q
          ? shown + " result" + (shown === 1 ? "" : "s")
          : total + " brands total";
      }
      if (directorySub) {
        directorySub.textContent = q
          ? 'Showing results for “' + query.trim() + '”'
          : (directorySub.dataset.default || directorySub.textContent);
      }
    }

    /* ---------- events ---------- */
    if (input) {
      input.addEventListener("input", function (e) {
        var v = e.target.value.trim();
        renderSuggestions(v);
        filter(v);
      });
      input.addEventListener("focus", function (e) {
        if (e.target.value.trim()) renderSuggestions(e.target.value.trim());
      });
      input.addEventListener("keydown", function (e) {
        if (e.key === "Escape" || e.key === "Enter") suggBox && suggBox.classList.remove("is-open");
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        input.value = "";
        filter("");
        suggBox && suggBox.classList.remove("is-open");
        input.focus();
      });
    }
    document.addEventListener("click", function (e) {
      if (suggBox && !e.target.closest(".bmbd-search-wrap")) suggBox.classList.remove("is-open");
    });

    /* ---------- lazy live counts ---------- */
    // if (root.dataset.countEnabled === "true") {
    //   initCounts(root);
    // }
  }

  function initCounts(root) {
    var base = root.dataset.countBase || "/collections/vendors";
    var suffix = root.dataset.countSuffix || "products";
    var slots = Array.prototype.slice.call(root.querySelectorAll("[data-count]"));
    console.log("Count slots:", slots.length);
    if (!slots.length) return;

    function apply(vendor, text) {
      root.querySelectorAll('[data-count]').forEach(function (el) {
        var card = el.closest(".bmbd-card");
        if (card && card.dataset.vendor === vendor && !el.dataset.done) {
          el.dataset.done = "1";
          el.classList.remove("is-loading");
          el.textContent = text;
        }
      });
    }

    function fetchCount(vendor, slot) {
      if (!vendor) return;
      if (countCache[vendor] !== undefined) { apply(vendor, countCache[vendor]); return; }
      slot.classList.add("is-loading");
      var url = base + "?q=" + encodeURIComponent(vendor) + "&view=count";
      fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (txt) {
          console.log("Vendor:", vendor);
          var n = parseInt((txt || "").trim(), 10);

          // Hide brands with zero products
          if (isNaN(n) || n === 0) {
            root.querySelectorAll('.bmbd-card').forEach(function (card) {
              if (card.dataset.vendor === vendor) {
                card.style.display = "none";
              }
            });

            // Hide empty letter groups
            groups.forEach(function (group) {
              if (group.querySelectorAll('.bmbd-card:not([style*="display: none"])').length === 0) {
                group.style.display = "none";
              }
            });

            return;
          }

          var text = n.toLocaleString() + " " + suffix;
          countCache[vendor] = text;
          apply(vendor, text);
        })
        .catch(function () {
          countCache[vendor] = "";
          apply(vendor, "");
        });
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var slot = entry.target;
          io.unobserve(slot);
          var card = slot.closest(".bmbd-card");
          fetchCount(card && card.dataset.vendor, slot);
        });
      }, { rootMargin: "200px 0px" });
      slots.forEach(function (s) { io.observe(s); });
    } else {
      slots.forEach(function (s) {
        var card = s.closest(".bmbd-card");
        fetchCount(card && card.dataset.vendor, s);
      });
    }
  }

  function boot() {
    document.querySelectorAll("[data-bmbd]").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  // Re-init when re-rendered inside the theme editor.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector("[data-bmbd]");
    if (root) init(root);
  });
})();